// @vendors
const Immutable = require('immutable');
//@ constants
const actionTypes = require('constants/actionTypes');
const {
    BROKER_CUSTOM_WALLET_GENERAL_VIEW
} = require('../constants/index');

const getPortfolios = require('./brokerCustomWalletGetPortfolios');
const contractsByPortfolio= require('./brokerCustomWalletContractsByPortfolio');
const editPortfolio= require('./brokerCustomWalletEditPortfolio');
const removePortfolio= require('./brokerCustomWalletRemovePortfolio');

const MAX_CUSTOM_WALLETS = 16;

const initialState = () => {
    return Immutable.Map().merge({
        customWallets: Immutable.List(),
        errorReceived: '',
        isFetching: true,
        isOnEditionMode: false,
        isWalletsRequestError: false,
        isCreateWalletRequestError: false,
        isRemoveWalletRequestError: false,
        customWalletIdToDelete: null,
        customWalletNameToDelete: null,
        waitingCustomWalletConfirmationDelete: false,
        waitingCustomWalletChangeDefault: false,
        idPortfolioOnEdition:'',
        deletingPortfolioOnEdition: false,
        idDefaultViewToSet: null,
        isGetDefaultViewError: '',
        namePortfolioOnEdition: '',
        waitingCustomWalletLeaveEdition: false,
        skipLeaveEditionModal: true,
        goToEdit: false,
        goToDelete: false,
        nextPortfolioToEdit: null,
        lessThanTheMaximumViews: true,
        canCreateNew: false,
        idPortfolioAccountDefaultView: Number(BROKER_CUSTOM_WALLET_GENERAL_VIEW),
        cancelDefaultViewModal: false
    });
};

function validateMaxWallets (state) {
    const valid = state.get('customWallets').size < MAX_CUSTOM_WALLETS;

    return state.merge({
        lessThanTheMaximumViews: valid,
        canCreateNew: valid
    });
}

const brokerCustomWalletPortfolios = (state = initialState(), action) => {
    switch (action.type) {
        //contractsByPortfolio
        case actionTypes.BROKER_CUSTOM_WALLET_CONTRACT_LIST_BY_PORTFOLIO_REQUEST:
            return contractsByPortfolio.mergeFetchingInWallet(state, action.idPortfolioAccount);
        case actionTypes.BROKER_CUSTOM_WALLET_CONTRACT_LIST_BY_PORTFOLIO_SUCCESS:
            return contractsByPortfolio.mergeContractInWallet(state, action.idPortfolioAccount,action.payload, action.enabledProducts);
        case actionTypes.BROKER_CUSTOM_WALLET_CONTRACT_LIST_BY_PORTFOLIO_ERROR:
            return contractsByPortfolio.mergeErrorInWallet(state, action.idPortfolioAccount, action.payload);
        //editportfolios
        case actionTypes.BROKER_CUSTOM_WALLET_UPDATE_CONTRACTS_LIST_BY_PORTFOLIO:
            return contractsByPortfolio.updatePortfolio(state, action.payload);
        case actionTypes.BROKER_CUSTOM_WALLET_PORTFOLIO_SET_ON_EDIT_MODE_ACCEPT:
            return editPortfolio.setOnEditionMode(state, action.payload.idPortfolioAccount).merge({
                idPortfolioOnEdition: action.payload.idPortfolioAccount,
                namePortfolioOnEdition: action.payload.name,
                skipLeaveEditionModal: false
            });
        case actionTypes.BROKER_CUSTOM_WALLET_PORTFOLIO_SET_ON_NEXT_EDIT_MODE_ACCEPT:
            return state.merge({
                nextPortfolioToEdit: action.payload.nextPortfolio
            });
        case actionTypes.BROKER_CUSTOM_WALLET_PORTFOLIO_SET_ON_EDIT_MODE_CANCEL:
            return editPortfolio.setOnViewMode(state, action.payload).merge({
                idPortfolioOnEdition: '',
                namePortfolioOnEdition: '',
                skipLeaveEditionModal: true
            });
        case actionTypes.BROKER_CUSTOM_WALLET_PORTFOLIO_SAVE_EDIT_MODE_SUCCESS:
            return state.merge({
                viewNameToSave: action.paylod.name,
                contractToSave: action.paylod.contracts
            });
        case actionTypes.BROKER_CUSTOM_WALLET_PORTFOLIO_LEAVE_EDITION_TO_DELETE_MODE_REQUEST:
            return state.merge({
                waitingCustomWalletLeaveEdition: true,
                goToDelete: true
            });

        case actionTypes.BROKER_CUSTOM_WALLET_PORTFOLIO_LEAVE_EDITION_TO_EDITION_MODE_REQUEST:
            return state.merge({
                waitingCustomWalletLeaveEdition: true,
                goToEdit: true
            });
        case actionTypes.BROKER_CUSTOM_WALLET_PORTFOLIO_LEAVE_EDITION_TO_OTHER_PAGE_CONFIRMED:
            return state.merge({
                skipLeaveEditionModal: true
            });
        case actionTypes.BROKER_CUSTOM_WALLET_PORTFOLIO_LEAVE_EDITION_TO_DELETE_MODE_CONFIRMED:
            return state.merge({
                waitingCustomWalletLeaveEdition: false,
                skipLeaveEditionModal: true,
                goToDelete: false
            });

        case actionTypes.BROKER_CUSTOM_WALLET_PORTFOLIO_LEAVE_EDITION_TO_EDITION_MODE_CONFIRMED:
            return state.merge({
                waitingCustomWalletLeaveEdition: false,
                skipLeaveEditionModal: false,
                goToEdit: false
            });
        case actionTypes.BROKER_CUSTOM_WALLET_PORTFOLIO_LEAVE_EDITION_MODE_CANCELED:
            return state.merge({
                waitingCustomWalletLeaveEdition: false,
                goToEdit: false,
                goToDelete: false
            });
        case actionTypes.BROKER_CUSTOM_WALLET_PORTFOLIO_CANCEL_EDITION:
             return state.merge({
                 skipLeaveEditionModal: true
             })
        //getPortfolios
        case actionTypes.BROKER_CUSTOM_WALLET_GET_PORTFOLIOS_LIST_SUCCESS:
            const customWallets = Immutable.fromJS(
                getPortfolios.parsePortfolios(action.payload)
            );
            return validateMaxWallets(state.merge({
                customWallets: customWallets,
                isWalletsRequestError: false,
                canCreateNew: true
            }));
        case actionTypes.BROKER_CUSTOM_WALLET_GET_PORTFOLIOS_LIST_ERROR:
            return state.merge({
                isWalletsRequestError: true,
                isFetching: false,
                errorReceived: action.payload
            });
        case actionTypes.BROKER_CUSTOM_WALLET_GET_PORTFOLIOS_LIST_REQUEST:
            return initialState().merge({
                isFetching: true
            });
        case actionTypes.BROKER_CUSTOM_WALLET_PORTFOLIO_SET_EXPANDED:
            return state.update('customWallets', (customWallets) => {
                return customWallets.map((customWallet) => {
                    if (customWallet.get('idPortfolioAccount') === action.payload.idPortfolioAccount) {
                        return customWallet.set('isExpanded', !customWallet.get('isExpanded'));
                    }
                    return customWallet;
                })
            });
        //removePortfolio
        case actionTypes.BROKER_CUSTOM_WALLET_REMOVE_SUCCESS:
            let newState = removePortfolio.removeWallet(state);
            if(action.deletingPortfolioOnEdition) {
                newState = newState.merge({
                    idPortfolioOnEdition: '',
                    namePortfolioOnEdition: '',
                    skipLeaveEditionModal: true
                })
            }
            return validateMaxWallets(newState);    
        case actionTypes.BROKER_CUSTOM_WALLET_REMOVE_ERROR:
            return state.merge({
                isFetching: false,
                isCustomWalletRemoveRequestError: true,
                errorReceived: action.payload,
                customWalletIdToDelete: null,
                customWalletNameToDelete: null,
                waitingCustomWalletConfirmationDelete: false,
            });
        case actionTypes.BROKER_CUSTOM_WALLET_REMOVE_REQUEST:
            return state;
        case actionTypes.BROKER_CUSTOM_WALLET_REMOVE_DATA_CHANGED:
            newState = state.merge({
                customWalletIdToDelete: action.customWalletIdToDelete,
                customWalletNameToDelete: action.customWalletNameToDelete,
                waitingCustomWalletConfirmationDelete: true,
            });
            if(action.deletingOnEdition) {
                return newState.merge({
                    deletingPortfolioOnEdition: true
                });
            } else {
                return newState
            }
        case actionTypes.BROKER_CUSTOM_WALLET_REMOVE_CANCELED:
            return state.merge({
                customWalletIdToDelete: null,
                customWalletNameToDelete: null,
                waitingCustomWalletConfirmationDelete: false,
            });
        case actionTypes.BROKER_CUSTOM_WALLET_CHANGE_DEFAULT_REQUEST:
            return state.merge({
                waitingCustomWalletChangeDefault: true
            });
        case actionTypes.BROKER_CUSTOM_WALLET_CHANGE_DEFAULT_CONFIRMED_SUCCESS:
            return state.merge({
                waitingCustomWalletChangeDefault: false,
                cancelDefaultViewModal: true,
                idDefaultViewToSet: null,
                idPortfolioAccountDefaultView: parseInt(action.payload.idDefaultViewToSet)
            });
        case actionTypes.BROKER_CUSTOM_WALLET_CHANGE_DEFAULT_CONFIRMED_FAIL:
            return state.merge({
                waitingCustomWalletChangeDefault: false,
                cancelDefaultViewModal: true,
                idDefaultViewToSet: null
            });
        case actionTypes.BROKER_CUSTOM_WALLET_CHANGE_DEFAULT_CHECKBOX_CHANGED:
            return state.merge({
                idDefaultViewToSet: action.payload.data,
                cancelDefaultViewModal: false
            });
        case actionTypes.BROKER_CUSTOM_WALLET_CHANGE_DEFAULT_CANCELED:
            return state.merge({
                waitingCustomWalletChangeDefault: false,
                cancelDefaultViewModal: true,
                idDefaultViewToSet: null
            });
        case actionTypes.BROKER_CUSTOM_WALLET_CHANGE_DEFAULT_CONFIRMED:
            return state.merge({
                waitingCustomWalletChangeDefault: false
            });
        case actionTypes.BROKER_GET_DEFAULT_VIEW_ID_SUCCESS:
            const portfolioDefaultViewId = action.payload.viewId;
            return contractsByPortfolio.setPortfolioDefaultView(
                state,
                portfolioDefaultViewId
            ).merge({
                isFetching : false,
                idPortfolioAccountDefaultView: Number(portfolioDefaultViewId)
            });
        case actionTypes.BROKER_GET_DEFAULT_VIEW_ID_FAILURE:
            return state.merge({
                isFetching : false,
                isGetDefaultViewError: action.payload.error
            });
        case actionTypes.BROKER_CUSTOM_WALLET_GET_PORTFOLIOS_LIST_DISABLE_BUTTON:
            return state.merge({
                canCreateNew: false
            });
        default:
            return state;
    }
};

module.exports = {
    brokerCustomWalletPortfolios,
    initialState,
};